import React from "react";
import { FILTERS } from "./filters";

/* Status filter chips. Rendered as a radio group: exactly one filter is active at a time, and aria-pressed communicates that to assistive tech. The five chips... */
/* `filters` lets a screen show a subset — My Companies has no "Listed", since
   everything it lists is already claimed. */
export const FilterChips = ({
  value = "all",
  onChange = () => {},
  filters = FILTERS,
  /* Purchased filters order states, not profile statuses, so the group needs
     to say what it actually filters. */
  label = "Filter results by status",
  className = "",
}) => (
  <div
    role="group"
    aria-label={label}
    className={`flex flex-nowrap gap-1 sm:gap-1.5 max-w-full [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
  >
    {filters.map((f) => {
      const active = value === f.id;
      return (
        <button
          key={f.id}
          type="button"
          onClick={() => onChange(f.id)}
          aria-pressed={active}
          className={`h-7 px-2.5 text-[11px] sm:h-8 sm:px-3.5 sm:text-[13px] rounded-full border font-semibold font-sans whitespace-nowrap shrink-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)] focus-visible:ring-offset-1 ${
            active
              ? "border-[var(--orange)] bg-[var(--orange-soft)] text-[var(--orange)]"
              : "border-[var(--line)] bg-white text-[var(--ink-2)] hover:border-[var(--line-2)]"
          }`}
        >
          {f.label}
        </button>
      );
    })}
  </div>
);

export default FilterChips;
